import * as yup from 'yup';
import { formatCurrencyNoDecimal } from '../utilities/numericFormat.js';

//* Critical illness cover
const CRITICAL_ILLNESS_COVER_SELECTED = 'Critical Illness can’t be selected without Life cover';
const CRITICAL_ILLNESS_COVER_EXCEED =
  "Critical Illness Cover Amount can't exceed the Life Cover Amount";

export const criticalIllnessCover = (person) => {
  const lifeCover = `${person}_lifeCover`;
  const personDetails = person;

  return {
    [`${person}_illnessCover`]: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable()
      .test('life-cover', CRITICAL_ILLNESS_COVER_SELECTED, function (value) {
        //when return is false then the error message is triggered
        return value == null || this.parent[lifeCover] ? true : false;
      })
      .test('criticalIllness-exceed', CRITICAL_ILLNESS_COVER_EXCEED, function (value) {
        //when return is false then the error message is triggered
        return value == null ? true : value <= this.parent[lifeCover];
      })
      .min(
        yup.ref('$' + personDetails + '_minCICover'),
        ({ min }) => `Minimum cover required is ${formatCurrencyNoDecimal(min)}`,
      )
      .max(
        yup.ref('$' + personDetails + '_maxCICover'),
        ({ max }) => `Maximum cover required is ${formatCurrencyNoDecimal(max)}`,
      ),
    // [`${person}_traumaCover`]: yup
    //   .string()
    //   .when('$' + personDetails + '_validateTraumaQuestion', {
    //     is: true,
    //     then: yup
    //       .string()
    //       .oneOf(['yes', 'no'])
    //       .required('You must answer the Total cover question'),
    //     otherwise: yup.string().nullable().notRequired(),
    //   })
    //   .test(
    //     'trauma-cover',
    //     "You've exceeded the $2m maximum amount of Trauma and Critical Illness cover available across all your policies",
    //     function (value) {
    //       //when return is false then the error message is triggered
    //       return value == null ? true : value === 'yes' ? false : true;
    //     },
    //   ),
  };
};
